import { Logger } from '@packages/shared/core/common/logger/interfaces';
import { isUndefined } from '@packages/shared/core/common/utils';
import { StorageInterface } from './interfaces';

export class SessionStorageClientService implements StorageInterface {
  constructor(private readonly logger: Logger) {}

  get<T = unknown>(key: string): T | null {
    if (!key) throw new Error('storage key may not be falsy');

    try {
      const storageValue: string | null = sessionStorage.getItem(key);

      if (!storageValue) {
        return null;
      }

      try {
        return JSON.parse(storageValue) as T;
      } catch {
        return storageValue as T;
      }
    } catch (err) {
      this.logger.warn(`Can't load value from session store for key: ${key}`);
      throw err;
    }
  }

  set(key: string, newValue: unknown): void {
    if (!key) throw new Error('storage key may not be falsy');

    if (isUndefined(newValue)) return;

    try {
      const value = typeof newValue === 'string' ? newValue : JSON.stringify(newValue);

      sessionStorage.setItem(key, value);
    } catch (err) {
      this.logger.warn(`Can't save value to session store for key: ${key}`);
      throw err;
    }
  }
}
